import { createAsyncThunk } from "@reduxjs/toolkit";

import { type ClientMealsPlanDetails } from "@fitness-app/data-models/entities/ClientNutrition";

import { type AsyncThunkCreator } from "../../../index";
import { MEALS_PLANS_REDUCER_NAME } from "../types";

type Payload = {
  dayId: string;
  mealId: string;
  productId: string;
};

export const deleteProductFromMealsPlan = createAsyncThunk<ClientMealsPlanDetails, Payload, AsyncThunkCreator<string>>(
  `${MEALS_PLANS_REDUCER_NAME}/deleteProductFromMealsPlan`,
  async (payload, { rejectWithValue, getState, extra: { db } }) => {
    const { traineeMealsPlan } = getState();

    if (!traineeMealsPlan.selectedMealsPlanDetails || traineeMealsPlan.selectedMealsPlanDetails.length === 0) {
      return rejectWithValue("No meals plan details");
    }

    const [plan] = traineeMealsPlan.selectedMealsPlanDetails;

    if (!plan) {
      return rejectWithValue("No meals plan");
    }

    const updatedDays = plan.weeks[0]?.days.map((day) =>
      day.id === payload.dayId
        ? {
            ...day,
            meals: day.meals.map((meal) =>
              meal.id === payload.mealId
                ? {
                    ...meal,
                    dishes: meal.dishes.filter((dish) => dish.id !== payload.productId),
                  }
                : meal,
            ),
          }
        : day,
    );

    const { error, data } = await db
      .from("client_meals_plan_details")
      .update({
        weeks: [
          {
            weekNumber: 1,
            days: updatedDays || [],
          },
        ],
        updatedAt: new Date().toISOString(),
      })
      .eq("id", plan.id)
      .select()
      .returns<ClientMealsPlanDetails[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return data[0]!;
  },
);
